import { Box, Grid } from "@mui/material";
import React, { useContext, useEffect } from "react";
// import * as React from 'react';
import { RootStoreContext } from "../../store";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
// import style from "./Team_up.module.css";
import style from "./CompanyIntroNew.module.css";
import Stack from "@mui/material/Stack";
// import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
// import CustomSCBG from "../../components/button_group/CustomSCBG";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { createTeam } from "../../services/TeamService";
import { getCoEditDoc } from "../../services/MilestoneService";
import { saveIntro } from "../../services/CompanyIntroService";
import { getAuth } from "firebase/auth";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const auth = getAuth();
const fieldList = [
  "智慧製造",
  "行銷科技",
  "電子商務",
  "資訊安全",
  "人工智慧",
  "教育創新",
  "共享經濟",
  "社會創新",
  "金融科技",
  "旅遊創新",
  "農食創新",
  "生醫/藥/醫材",
  "半導體",
  "數位平台",
  "物聯網IOT",
  "新農業",
  "循環經濟",
  "AR/VR/MR",
  "高齡/照護",
  "文化創意",
  "健身/運動/健康",
  "綠能科技",
  "區塊鏈",
  "智慧零售",
];
const { useState } = React;

function CompanyIntroNew() {
  const { CompanyIntroStore } = useContext(RootStoreContext);
  const {
    problemStatement,
    solution,
    whyNow,
    videotitle,
    companyname,
    field,
    slogan,
    intro,
    unique,
    market,
    advantage,
    marketvalue,
    businessmodel,
    teamintro,
  } = CompanyIntroStore;
  const {
    growth,
    outputvalue,
    firstcomp,
    secondcomp,
    thirdcomp,
    financepredict,
  } = CompanyIntroStore;
  const {
    assetone,
    assettwo,
    assetthree,
    assetfour,
    assetfive,
    moneyone,
    moneytwo,
    moneythree,
    moneyfour,
    moneyfive,
  } = CompanyIntroStore;
  const { updateData } = CompanyIntroStore;

  const [LogoFile, setLogoFile] = useState();
  const [UniquenessFile, setUniquenessFile] = useState();
  const [AdvantageFile, setAdvantageFile] = useState();
  const [MarketFile, setMarketFile] = useState();
  const [FirstCompFile, setFirstCompFile] = useState();
  const [SecondCompFile, setSecondCompFile] = useState();
  const [ThirdCompFile, setThirdCompFile] = useState();
  const [VideoFile, setVideoFile] = useState();
  const [teamDoc, setTeamDoc] = useState("");
  const [companyDoc, setCompanyDoc] = useState("");
  const [marketDoc, setMarketDoc] = useState("");
  const [productDoc, setProductDoc] = useState("");
  const [marketStrategyDoc, setMarketStrategyDoc] = useState("");
  const [bizStrategyDoc, setbizStrategyDoc] = useState("");
  const [finStatementsDoc, setFinStatementsDoc] = useState("");

  useEffect(() => {
    getCoEditDoc("0").then((value) => {
      console.log(value.content);
      setTeamDoc(value.content);
    });
    getCoEditDoc("2").then((value) => {
      console.log(value.content);
      setCompanyDoc(value.content);
    });
    getCoEditDoc("3").then((value) => {
      console.log(value.content);
      setMarketDoc(value.content);
    });
    getCoEditDoc("4").then((value) => {
      console.log(value.content);
      setProductDoc(value.content);
    });
    getCoEditDoc("5").then((value) => {
      console.log(value.content);
      setMarketStrategyDoc(value.content);
    });
    getCoEditDoc("6").then((value) => {
      console.log(value.content);
      setbizStrategyDoc(value.content);
    });
    getCoEditDoc("7").then((value) => {
      console.log(value.content);
      setFinStatementsDoc(value.content);
    });
  });

  const selectLogoFile = (event) => {
    setLogoFile(URL.createObjectURL(event.target.files[0]));
  };
  const selectUniquenessFile = (event) => {
    setUniquenessFile(URL.createObjectURL(event.target.files[0]));
  };
  const selectAdvantageFile = (event) => {
    setAdvantageFile(URL.createObjectURL(event.target.files[0]));
  };
  const selectMarketFile = (event) => {
    setMarketFile(URL.createObjectURL(event.target.files[0]));
  };
  const selectFirstCompFile = (event) => {
    setFirstCompFile(URL.createObjectURL(event.target.files[0]));
  };
  const selectSecondCompFile = (event) => {
    setSecondCompFile(URL.createObjectURL(event.target.files[0]));
  };
  const selectThirdCompFile = (event) => {
    setThirdCompFile(URL.createObjectURL(event.target.files[0]));
  };
  const selectVideoFile = (event) => {
    setVideoFile(URL.createObjectURL(event.target.files[0]));
  };

  return (
    <Grid
      container
      className={style.main}
      direction="row"
      justifyContent="center"
      alignItems="center"
    >
      <Box className={style.box}>
        <Stack spacing={5}>
          <div>
            <Accordion className={style.accordion}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={style.formTitle}>
                  1. Problem Statement
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  className={style.introTF} //style.變數TF 待css檔完成
                  multiline
                  rows={3}
                  value={problemStatement}
                  onChange={(e) => {
                    updateData("problemStatement", e.target.value);
                  }}
                />
              </AccordionDetails>
            </Accordion>
            <br />
            <Accordion className={style.accordion}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className={style.formTitle}>2. Solution</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  className={style.introTF} //style.變數TF 待css檔完成
                  multiline
                  rows={3}
                  value={solution}
                  onChange={(e) => {
                    updateData("solution", e.target.value);
                  }}
                />
              </AccordionDetails>
            </Accordion>
            <br />
            <Accordion className={style.accordion}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className={style.formTitle}>3. Why now?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  className={style.introTF} //style.變數TF 待css檔完成
                  multiline
                  rows={3}
                  value={whyNow}
                  onChange={(e) => {
                    updateData("whyNow", e.target.value);
                  }}
                />
              </AccordionDetails>
            </Accordion>
            <br />
            <Accordion className={style.accordion}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className={style.formTitle}>4. Video</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div>
                  {VideoFile && (
                    <video width="400" controls>
                      <source src={VideoFile} />
                    </video>
                  )}
                  {VideoFile ? (
                    <div>
                      <Typography className={style.formTitle}>
                        VIDEO TITLES:
                      </Typography>
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        className={style.videotitleTF} //style.變數TF 待css檔完成
                        value={videotitle}
                        onChange={(e) => {
                          updateData("videotitle", e.target.value);
                        }}
                      />
                      <br />
                      <button
                        className={style.formBtn}
                        onClick={() => {
                          setVideoFile();
                        }}
                      >
                        取消
                      </button>{" "}
                      {/*如果已經有LogoFile已經有檔案上傳的話*/}
                      <button className={style.formBtn}>確定提交</button>
                    </div>
                  ) : (
                    <label className={style.formBtn}>
                      <input
                        type="file"
                        style={{ display: "none" }}
                        onChange={selectVideoFile}
                      />{" "}
                      {/*如果LogoFile還未有檔案上傳*/}
                      upload
                    </label>
                  )}
                </div>
              </AccordionDetails>
            </Accordion>
            <br />
            <Accordion className={style.accordion}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className={style.formTitle}>5. 公司資訊</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography className={style.formTitle}>
                        公司介紹
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div
                        dangerouslySetInnerHTML={{ __html: companyDoc }}
                      ></div>
                    </AccordionDetails>
                  </Accordion>
                </div>
                <div>
                  <Typography className={style.formTitle}>公司名稱:</Typography>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.companynameTF} //style.變數TF 待css檔完成
                    value={companyname}
                    onChange={(e) => {
                      updateData("companyname", e.target.value);
                    }}
                  />
                </div>
                <div>
                  <Typography className={style.formTitle}>服務領域:</Typography>
                  <FormControl className={style.selectField}>
                    <Select
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      value={field}
                      label="Field"
                      onChange={(e) => {
                        updateData("field", e.target.value);
                      }}
                    >
                      {fieldList.map((item) => (
                        <MenuItem value={item}>{item}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div>
                  <Typography className={style.formTitle}>
                    公司slogan:
                  </Typography>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.sloganTF} //style.變數TF 待css檔完成
                    value={slogan}
                    onChange={(e) => {
                      updateData("slogan", e.target.value);
                    }}
                  />
                </div>
                <div>
                  <Typography className={style.formTitle}>公司簡介:</Typography>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.introTF} //style.變數TF 待css檔完成
                    multiline
                    rows={3}
                    value={intro}
                    onChange={(e) => {
                      updateData("intro", e.target.value);
                    }}
                  />
                </div>
                <div>
                  <Typography className={style.formTitle}>公司Logo:</Typography>
                  {/* {VideoFile&&<video width="400" controls>
                                <source src={VideoFile} /> */}
                  {LogoFile && <img width="400" src={LogoFile} alt="logo" />}
                  {LogoFile ? (
                    <div>
                      <button
                        className={style.formBtn}
                        onClick={() => {
                          setLogoFile();
                        }}
                      >
                        取消
                      </button>{" "}
                      {/*如果已經有LogoFile已經有檔案上傳的話*/}
                      <button className={style.formBtn}>確定提交</button>
                    </div>
                  ) : (
                    <label className={style.formBtn}>
                      <input
                        type="file"
                        style={{ display: "none" }}
                        onChange={selectLogoFile}
                      />{" "}
                      {/*如果LogoFile還未有檔案上傳*/}
                      upload
                    </label>
                  )}
                </div>
              </AccordionDetails>
            </Accordion>
            <br />
            <Accordion className={style.accordion}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className={style.formTitle}>
                  6. 產品服務特點
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography className={style.formTitle}>
                        產品策略與競爭者
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div
                        dangerouslySetInnerHTML={{ __html: productDoc }}
                      ></div>
                    </AccordionDetails>
                  </Accordion>
                </div>
                <div>
                  <Typography className={style.formTitle}>
                    產品服務特點:
                  </Typography>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.uniqueTF} //style.變數TF 待css檔完成
                    value={unique}
                    onChange={(e) => {
                      updateData("unique", e.target.value);
                    }}
                  />
                </div>
                <div>
                  <Typography className={style.formTitle}>
                    產品服務特點icon:
                  </Typography>
                  {UniquenessFile && (
                    <img width="400" src={UniquenessFile} alt="uniqueness" />
                  )}
                  {UniquenessFile ? (
                    <div>
                      <button
                        className={style.formBtn}
                        onClick={() => {
                          setUniquenessFile();
                        }}
                      >
                        重新上傳
                      </button>{" "}
                      {/*如果已經有LogoFile已經有檔案上傳的話*/}
                      <button className={style.formBtn}>確定提交</button>
                    </div>
                  ) : (
                    <label className={style.formBtn}>
                      <input
                        type="file"
                        style={{ display: "none" }}
                        onChange={selectUniquenessFile}
                      />{" "}
                      {/*如果LogoFile還未有檔案上傳*/}
                      upload
                    </label>
                  )}
                </div>
                <div>
                  <Typography className={style.formTitle}>
                    產品服務優勢:
                  </Typography>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.advantageTF} //style.變數TF 待css檔完成
                    value={advantage}
                    onChange={(e) => {
                      updateData("advantage", e.target.value);
                    }}
                  />
                </div>
                <div>
                  <Typography className={style.formTitle}>
                    產品服務優勢icon:
                  </Typography>
                  {AdvantageFile && (
                    <img width="400" src={AdvantageFile} alt="advantage" />
                  )}
                  {AdvantageFile ? (
                    <div>
                      <button
                        className={style.formBtn}
                        onClick={() => {
                          setAdvantageFile();
                        }}
                      >
                        重新上傳
                      </button>{" "}
                      {/*如果已經有LogoFile已經有檔案上傳的話*/}
                      <button className={style.formBtn}>確定提交</button>
                    </div>
                  ) : (
                    <label className={style.formBtn}>
                      <input
                        type="file"
                        style={{ display: "none" }}
                        onChange={selectAdvantageFile}
                      />{" "}
                      {/*如果LogoFile還未有檔案上傳*/}
                      upload
                    </label>
                  )}
                </div>
              </AccordionDetails>
            </Accordion>
            <br />
            <Accordion className={style.accordion}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className={style.formTitle}>7. 市場規模</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography className={style.formTitle}>
                        市場策略與風險
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div
                        dangerouslySetInnerHTML={{ __html: marketDoc }}
                      ></div>
                    </AccordionDetails>
                  </Accordion>
                </div>
                <div>
                  <Typography className={style.formTitle}>
                    市場分布描述:
                  </Typography>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.marketTF} //style.變數TF 待css檔完成
                    multiline
                    rows={3}
                    value={market}
                    onChange={(e) => {
                      updateData("market", e.target.value);
                    }}
                  />
                </div>
                <div>
                  <Typography className={style.formTitle}>
                    市場分布圖:
                  </Typography>
                  {MarketFile && (
                    <img width="400" src={MarketFile} alt="market" />
                  )}
                  {MarketFile ? (
                    <div>
                      <button
                        className={style.formBtn}
                        onClick={() => {
                          setMarketFile();
                        }}
                      >
                        重新上傳
                      </button>{" "}
                      {/*如果已經有LogoFile已經有檔案上傳的話*/}
                      <button className={style.formBtn}>確定提交</button>
                    </div>
                  ) : (
                    <label className={style.formBtn}>
                      <input
                        type="file"
                        style={{ display: "none" }}
                        onChange={selectMarketFile}
                      />{" "}
                      {/*如果LogoFile還未有檔案上傳*/}
                      upload
                    </label>
                  )}
                </div>
                <div>
                  <Typography className={style.formTitle}>
                    全球總市值描述:
                  </Typography>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.marketvalueTF} //style.變數TF 待css檔完成
                    multiline
                    rows={3}
                    placeholder="（write your markdown）"
                    value={marketvalue}
                    onChange={(e) => {
                      updateData("marketvalue", e.target.value);
                    }}
                  />
                </div>
                <div>
                  <Typography className={style.formTitle}>
                    產業成長率描述:
                  </Typography>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.growthTF} //style.變數TF 待css檔完成
                    multiline
                    rows={3}
                    placeholder="（write your markdown）"
                    value={growth}
                    onChange={(e) => {
                      updateData("growth", e.target.value);
                    }}
                  />
                </div>
                <div>
                  <Typography className={style.formTitle}>
                    產業年產值描述:
                  </Typography>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.outputvalueTF} //style.變數TF 待css檔完成
                    multiline
                    rows={3}
                    placeholder="（write your markdown）"
                    value={outputvalue}
                    onChange={(e) => {
                      updateData("outputvalue", e.target.value);
                    }}
                  />
                </div>
              </AccordionDetails>
            </Accordion>
            <br />
            <Accordion className={style.accordion}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className={style.formTitle}>
                  8. 競爭者分析
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography className={style.formTitle}>
                        產品策略與競爭者
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div dangerouslySetInnerHTML={{ __html: productDoc }} />
                    </AccordionDetails>
                  </Accordion>
                </div>
                <div>
                  <Typography className={style.formTitle}>
                    首要競爭者:
                  </Typography>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.firstcompTF} //style.變數TF 待css檔完成
                    value={firstcomp}
                    onChange={(e) => {
                      updateData("firstcomp", e.target.value);
                    }}
                  />
                </div>
                <div>
                  <Typography className={style.formTitle}>
                    首要競爭者圖片:
                  </Typography>
                  {FirstCompFile && (
                    <img
                      width="400"
                      src={FirstCompFile}
                      alt="first competitor"
                    />
                  )}
                  {FirstCompFile ? (
                    <div>
                      <button
                        className={style.formBtn}
                        onClick={() => {
                          setFirstCompFile();
                        }}
                      >
                        重新上傳
                      </button>{" "}
                      {/*如果已經有LogoFile已經有檔案上傳的話*/}
                      <button className={style.formBtn}>確定提交</button>
                    </div>
                  ) : (
                    <label className={style.formBtn}>
                      <input
                        type="file"
                        style={{ display: "none" }}
                        onChange={selectFirstCompFile}
                      />{" "}
                      {/*如果LogoFile還未有檔案上傳*/}
                      upload
                    </label>
                  )}
                </div>
                <div>
                  <Typography className={style.formTitle}>
                    次要競爭者:
                  </Typography>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.secondcompTF} //style.變數TF 待css檔完成
                    value={secondcomp}
                    onChange={(e) => {
                      updateData("secondcomp", e.target.value);
                    }}
                  />
                </div>
                <div>
                  <Typography className={style.formTitle}>
                    次要競爭者圖片:
                  </Typography>
                  {SecondCompFile && (
                    <img
                      width="400"
                      src={SecondCompFile}
                      alt="second competitor"
                    />
                  )}
                  {SecondCompFile ? (
                    <div>
                      <button
                        className={style.formBtn}
                        onClick={() => {
                          setSecondCompFile();
                        }}
                      >
                        重新上傳
                      </button>{" "}
                      {/*如果已經有LogoFile已經有檔案上傳的話*/}
                      <button className={style.formBtn}>確定提交</button>
                    </div>
                  ) : (
                    <label className={style.formBtn}>
                      <input
                        type="file"
                        style={{ display: "none" }}
                        onChange={selectSecondCompFile}
                      />{" "}
                      {/*如果LogoFile還未有檔案上傳*/}
                      upload
                    </label>
                  )}
                </div>
                <div>
                  <Typography className={style.formTitle}>
                    第三競爭者:
                  </Typography>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.thirdcompTF} //style.變數TF 待css檔完成
                    value={thirdcomp}
                    onChange={(e) => {
                      updateData("thirdcomp", e.target.value);
                    }}
                  />
                </div>
                <div>
                  <Typography className={style.formTitle}>
                    第三競爭者圖片:
                  </Typography>
                  {ThirdCompFile && (
                    <img
                      width="400"
                      src={ThirdCompFile}
                      alt="third competitor"
                    />
                  )}
                  {ThirdCompFile ? (
                    <div>
                      <button
                        className={style.formBtn}
                        onClick={() => {
                          setThirdCompFile();
                        }}
                      >
                        重新上傳
                      </button>{" "}
                      {/*如果已經有LogoFile已經有檔案上傳的話*/}
                      <button className={style.formBtn}>確定提交</button>
                    </div>
                  ) : (
                    <label className={style.formBtn}>
                      <input
                        type="file"
                        style={{ display: "none" }}
                        onChange={selectThirdCompFile}
                      />{" "}
                      {/*如果LogoFile還未有檔案上傳*/}
                      upload
                    </label>
                  )}
                </div>
              </AccordionDetails>
            </Accordion>
            <br />
            <Accordion className={style.accordion}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className={style.formTitle}>9. 財務報表</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography className={style.formTitle}>
                        財務報表與五年期財務計畫
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div
                        dangerouslySetInnerHTML={{ __html: finStatementsDoc }}
                      />
                    </AccordionDetails>
                  </Accordion>
                </div>
                <div>
                  <Typography className={style.formTitle}>
                    財務預測描述:
                  </Typography>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.financepredictTF} //style.變數TF 待css檔完成
                    multiline
                    rows={3}
                    value={financepredict}
                    onChange={(e) => {
                      updateData("financepredict", e.target.value);
                    }}
                  />
                </div>
                <div>
                  <Typography className={style.formTitle}>
                    總資產預測:
                  </Typography>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.assetpredictTF} //style.變數TF 待css檔完成
                    placeholder="第一年"
                    value={assetone}
                    onChange={(e) => {
                      updateData("assetpredict", e.target.value);
                    }}
                  />
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.assettwoTF} //style.變數TF 待css檔完成
                    placeholder="第二年"
                    value={assettwo}
                    onChange={(e) => {
                      updateData("assettwo", e.target.value);
                    }}
                  />
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.assetthreeTF} //style.變數TF 待css檔完成
                    placeholder="第三年"
                    value={assetthree}
                    onChange={(e) => {
                      updateData("assetthree", e.target.value);
                    }}
                  />
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.assetfourTF} //style.變數TF 待css檔完成
                    placeholder="第四年"
                    value={assetfour}
                    onChange={(e) => {
                      updateData("assetfour", e.target.value);
                    }}
                  />
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.assetfiveTF} //style.變數TF 待css檔完成
                    placeholder="第五年"
                    value={assetfive}
                    onChange={(e) => {
                      updateData("assetfive", e.target.value);
                    }}
                  />
                </div>
                <div>
                  <Typography className={style.formTitle}>
                    現金流量預測:
                  </Typography>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.moneyoneTF} //style.變數TF 待css檔完成
                    placeholder="第一年"
                    value={moneyone}
                    onChange={(e) => {
                      updateData("moneyone", e.target.value);
                    }}
                  />
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.moneytwoTF} //style.變數TF 待css檔完成
                    placeholder="第二年"
                    value={moneytwo}
                    onChange={(e) => {
                      updateData("moneytwo", e.target.value);
                    }}
                  />
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.moneythreeTF} //style.變數TF 待css檔完成
                    placeholder="第三年"
                    value={moneythree}
                    onChange={(e) => {
                      updateData("moneythree", e.target.value);
                    }}
                  />
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.moneyfourTF} //style.變數TF 待css檔完成
                    placeholder="第四年"
                    value={moneyfour}
                    onChange={(e) => {
                      updateData("moneyfour", e.target.value);
                    }}
                  />
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.moneyfiveTF} //style.變數TF 待css檔完成
                    placeholder="第五年"
                    value={moneyfive}
                    onChange={(e) => {
                      updateData("moneyfive", e.target.value);
                    }}
                  />
                </div>
              </AccordionDetails>
            </Accordion>
            <br />
            <Accordion className={style.accordion}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className={style.formTitle}>
                  10. 商業模式
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography className={style.formTitle}>
                        商業模式
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div
                        dangerouslySetInnerHTML={{ __html: bizStrategyDoc }}
                      />
                    </AccordionDetails>
                  </Accordion>
                </div>
                <div>
                  <Typography className={style.formTitle}>
                    商業模式描述:
                  </Typography>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.businessmodelTF} //style.變數TF 待css檔完成
                    multiline
                    rows={3}
                    value={businessmodel}
                    onChange={(e) => {
                      updateData("businessmodel", e.target.value);
                    }}
                  />
                </div>
              </AccordionDetails>
            </Accordion>
            <br />
            <Accordion className={style.accordion}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className={style.formTitle}>
                  11. 團隊成員
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography className={style.formTitle}>
                        團隊管理與成員介紹
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div dangerouslySetInnerHTML={{ __html: teamDoc }}></div>
                    </AccordionDetails>
                  </Accordion>
                </div>
                <div>
                  <Typography className={style.formTitle}>團隊介紹:</Typography>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    className={style.teamintroTF} //style.變數TF 待css檔完成
                    multiline
                    rows={3}
                    value={teamintro}
                    onChange={(e) => {
                      updateData("teamintro", e.target.value);
                    }}
                  />
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
        </Stack>
        <Box mt={13}>
          <Stack direction="row" justifyContent="flex-end" spacing={2}>
            <Link to={"/CompanyIntroHome"}>
              <button className={style.cancelBtn}>取消</button>{" "}
              {/*  //最後submit出去和取消回到"組建團隊"頁面 */}
            </Link>
            <Link to={"/CompanyIntroHome"}>
              <button
                className={style.submitBtn}
                onClick={(e) => {
                  saveIntro({
                    problemStatement: problemStatement,
                    solution: solution,
                    whyNow: whyNow,
                    videotitle: videotitle,
                    companyname: companyname,
                    field: field,
                    slogan: slogan,
                    intro: intro,
                    advantage: advantage,
                    unique: unique,
                    market: market,
                    marketvalue: marketvalue,
                    businessmodel: businessmodel,
                    teamintro: teamintro,
                    growth: growth,
                    outputvalue: outputvalue,
                    firstcomp: firstcomp,
                    secondcomp: secondcomp,
                    thirdcomp: thirdcomp,
                    financepredict: financepredict,
                    assetone: assetone,
                    assettwo: assettwo,
                    assetthree: assetthree,
                    assetfour: assetfour,
                    assetfive: assetfive,
                    moneyone: moneyone,
                    moneytwo: moneytwo,
                    moneythree: moneythree,
                    moneyfour: moneyfour,
                    moneyfive: moneyfive,
                  });
                }}
              >
                儲存公司資料
              </button>
            </Link>
          </Stack>
        </Box>
      </Box>
    </Grid>
  );
}

export default observer(CompanyIntroNew);
